module.exports = __webpack_public_path__ + "img/Grooming.260a4cd0.jpg";